import { Box, Card, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTextField from '../../components/customFields/CustomTextField'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import "./calendar.css"
import BlueSmallButton from '../../components/customButtons/BlueSmallButton';
import DisableBlueSmallButton from '../../components/customButtons/DisableSmallBlueButton';
import PrimarySmallBlueButton from '../../components/customButtons/PrimarySmallBlueButton';
import { useNavigate } from 'react-router-dom';
import { createEnrollEnquiry, getEnrolSlot } from '../testPrepDashboard/Api/DashboardApi';
import ConfimationPopup from '../../components/customPopup/ConfimationPopup';
import ErrorPopup from '../../components/customPopup/ErrorPopup';
import Loader from '../../../SAPPages/components/Loader/Loader';
import InfoIcon from "@mui/icons-material/Info";
export default function DateAndClassInfo({ classData,
    packageData }) {
    const [startDate, setStartDate] = useState(null);
    const userId = localStorage.getItem("userId")
    const [openErrorPopup, setOpenErrorPopup] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [demoDatesData, setDemoDatesData] = useState([]);
    const [slotLoading, setSlotLoading] = useState(false);

    const [showIsdemoMessage, setShowIsdemoMessage] = useState(false);

    const navigate = useNavigate()


    const handleSearchEnrolDates = async () => {
        setSlotLoading(true);
        try {
            const payload = {
                class_id: classData?.id,
                user_id: parseInt(userId),
            };

            const response = await getEnrolSlot(payload);
            if (response.status === 200) {
                setDemoDatesData(response?.data);
             
                setSlotLoading(false);

                if (response?.is_data === false) {
                    setShowIsdemoMessage(true);
                }
            } else if ([400, 401, 500].includes(response.status)) {
                setSlotLoading(false);
            
                if (response?.is_data === false) {
                    setShowIsdemoMessage(true);
                }
            }
        } catch (error) {
            setSlotLoading(false);
         
        }
    };

    const formatDate = (date) => {
        return date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
        // gives YYYY-MM-DD in IST
    };

    // Only allow dates that have slots
    const filterDate = (date) => {
        const dateStr = formatDate(date);
        const dateObj = demoDatesData.find((d) => d.date === dateStr);
        return dateObj?.is_slot === true;
    };

    // Highlight dates with available slots
    const customDayClass = (date) => {
        const dateStr = formatDate(date);
        const dateObj = demoDatesData.find((d) => d.date === dateStr);

        if (dateObj?.is_slot === true) {
            return "react-datepicker__day--highlighted-pink"; // pink
        } else {
            return "react-datepicker__day--disabled"; // disabled
        }
    };


    
    useEffect(() => {
        handleSearchEnrolDates();
    }, [])


    // error popup

    const handleOpenErrorPopup = () => {
        setOpenErrorPopup(true);
    };

    const handleCloseErrorPopup = () => {
        setOpenErrorPopup(false);
    };

    const handleNavigateToCheckout = async () => {

        try {
            const payload = {
                class_id: classData?.id,
                user_id: parseInt(userId)
            };

            const response = await createEnrollEnquiry(payload);
            if (response.status === 201) {
                const enquirydata = response?.data
                navigate('/test-prep/checkout', {
                    state: { classData, packageData, enquirydata, startDate },
                });

            } else if ([400, 401, 500].includes(response.status)) {
                setErrorMessage(response?.message)
                handleOpenErrorPopup();

            }
        } catch (error) {
            setErrorMessage("Internal Server Error")
            handleOpenErrorPopup();
        }


    };



    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center" gap={1}>
                    <Box width={25}>
                        <img src='/newdashboard/Checkout\10-102298_-party-popper-emoji-party-popper-emoji.png' />
                    </Box>
                    <Typography Typography color="#A314AA"
                        fontFamily="Inter"
                        fontSize="24px"
                        lineHeight="100%"
                        letterSpacing="0px"

                        style={{ fontWeight: 400 }}>
                        Journey Starts Here !

                    </Typography>
                </Grid>

                <Grid item xs={12} textAlign="center">
                    <Typography Typography color="#444444"
                        fontFamily="Inter"
                        fontSize="16px"
                        lineHeight="100%"
                        letterSpacing="0%"

                        style={{ fontWeight: 400 }}>
                        Choose a date to begin your learning journey.

                    </Typography>
                </Grid>

                <Grid item xs={12} mt={1}>
                    <Box sx={{ width: "100%", height: "2px", background: "linear-gradient(to right, #FFFFFF, #A120BB, #FFFFFF)", }}></Box>
                </Grid>

                <Grid item xs={12} mt={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6} >
                            <Typography
                                fontSize="14px"
                                color="#572575"
                                mb={1}
                                sx={{
                                    fontWeight: 400,
                                    fontFamily: "Inter",
                                    fontStyle: "normal",
                                    letterSpacing: "0.1px",
                                    verticalAlign: "middle",
                                    lineHeight: "100%",
                                }}
                            >
                                Package
                            </Typography>

                            <CustomTextField

                                fullWidth
                                fontSize={14}
                                type="text"
                                borderColor="#E6E2F7"
                                color="#9D0385"
                                fontWeight={700}
                                value={packageData?.package_name}
                                readOnly
                            />

                        </Grid>



{ demoDatesData.length>0 && ( 
                        <Grid item xs={12} md={6}>
                            <Typography
                                fontSize="14px"
                                color="#572575"
                                mb={1}
                                sx={{
                                    fontWeight: 400,
                                    fontFamily: "Inter",
                                    fontStyle: "normal",
                                    letterSpacing: "0.1px",
                                    verticalAlign: "middle",
                                    lineHeight: "100%",
                                }}
                            >
                                Select your preferred start date
                            </Typography>

                            <DatePicker
                                fullWidth

                                selected={startDate}
                                onChange={(date) => {
                                    setStartDate(date);

                                }}
                                filterDate={filterDate}
                                dayClassName={customDayClass}

                                dateFormat="dd - MM - yyyy"
                                customInput={
                                    <CustomTextField
                                        fullWidth
                                        variant="outlined"
                                        borderColor="#E6E2F7"
                                        size="small"
                                        color="#9D0385"
                                        fontWeight={700}
                                        fontSize={13}

                                        InputProps={{
                                            endAdornment: (
                                                <CalendarTodayIcon
                                                    style={{ cursor: "pointer", fontSize: "1rem" }}
                                                />
                                            ),
                                        }}
                                    />
                                }
                            />

                        </Grid>
                        )}

                        {slotLoading && (
          <Grid item xs={12} textAlign="center">
            <Loader text="Loading Class Slots ..." height="20vh" />
          </Grid>
        )}

        {!slotLoading  && showIsdemoMessage && (
          <Grid item xs={12} textAlign="center">
            <Box
              sx={{
                background: "#BA15150F",
                padding: "10px",
                borderRadius: "8px",
              }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap={1}
            >
              <InfoIcon style={{ color: "#BA1515" }} />
              <Typography
                fontSize="12px"
                color="#BA1515"
                sx={{
                  fontWeight: 400,
                  fontFamily: "Inter",
                  lineHeight: "100%",
                  fontStyle: "normal",
                  letterSpacing: "0%",
                }}
              >
                No slots available for the selected criteria in the next 30 days
                days.
              </Typography>
            </Box>
          </Grid>
        )}
                    </Grid>
                </Grid>

                <Grid item xs={12}>

                    <Card sx={{ border: "1px solid #EEEEEE", p: 2, width: "100%", borderRadius: "6px" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} container gap={1} alignItems="center">
                                <Box width={20} height={20}>
                                    <img src='/newdashboard/Checkout\Vector.png' />
                                </Box>
                                <Typography fontSize="16px"
                                    color="#572575"

                                    sx={{
                                        fontWeight: 400,
                                        fontFamily: "Inter",
                                        fontStyle: "normal",
                                        letterSpacing: "0.1px",
                                        verticalAlign: "middle",
                                        lineHeight: "100%",
                                    }}>
                                    Your Selected Class Details Summary
                                </Typography>
                            </Grid>

                            <Grid item xs={12} height="100%">

                                <Grid container height="100%" >
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Grid container  >


                                            <Grid item xs={12}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12} sm={6} >
                                                        <Box display="flex" alignItems="center" flexDirection="row" gap={1}>
                                                            <Box width={30} >
                                                                <img src='/newdashboard/Checkout/Group 1171283449 (5).png' />
                                                            </Box>
                                                            <Typography textAlign="start"
                                                                color="#000000"
                                                                fontFamily="Inter"
                                                                fontSize="12px"
                                                                lineHeight="100%"
                                                                letterSpacing="0px"
                                                                fontStyle="normal"
                                                                style={{ fontWeight: 400 }}>
                                                                {classData?.name}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>



                                                    <Grid item xs={12} sm={6} >
                                                        <Box display="flex" alignItems="center" flexDirection="row" gap={1}>
                                                            <Box width={30} >
                                                                <img src='/newdashboard/Checkout/Group 1171283449 (1).png' />
                                                            </Box>
                                                            <Typography textAlign="start"
                                                                color="#000000"
                                                                fontFamily="Inter"
                                                                fontSize="12px"
                                                                lineHeight="100%"
                                                                letterSpacing="0px"
                                                                fontStyle="normal"
                                                                style={{ fontWeight: 400 }}>
                                                                {classData?.trainer_id?.first_name} {classData?.trainer_id?.last_name}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>

                                                    <Grid item xs={12} sm={6}  >
                                                        <Box display="flex" alignItems="center" flexDirection="row" gap={1}>
                                                            <Box width={30} >
                                                                <img src='/newdashboard/Checkout/Group 1171283449 (2).png' />
                                                            </Box>
                                                            <Typography textAlign="start"
                                                                color="#000000"
                                                                fontFamily="Inter"
                                                                fontSize="12px"
                                                                lineHeight="100%"
                                                                letterSpacing="0px"
                                                                fontStyle="normal"
                                                                style={{ fontWeight: 400 }}>
                                                                {classData?.mode_of_delivery === "offline" ? "Offline" : "Online"}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} >
                                                        <Box display="flex" alignItems="center" flexDirection="row" gap={1}>
                                                            <Box width={30} >
                                                                <img src='/newdashboard/Checkout/Group 1171283449 (3).png' />
                                                            </Box>
                                                            <Typography textAlign="start"
                                                                color="#000000"
                                                                fontFamily="Inter"
                                                                fontSize="12px"
                                                                lineHeight="100%"
                                                                letterSpacing="0px"
                                                                fontStyle="normal"
                                                                style={{ fontWeight: 400 }}>
                                                                   {classData?.day?.map(day => day).join(", ")}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>

                                                    {classData?.mode_of_delivery === "offline" && (
                                                        <>
                                                            <Grid item xs={12} sm={6} >
                                                                <Box display="flex" alignItems="center" flexDirection="row" gap={1}>
                                                                    <Box width={30} >
                                                                        <img src='/newdashboard/Checkout/Group 1171283449 (4).png' />
                                                                    </Box>
                                                                    <Typography textAlign="start"
                                                                        color="#000000"
                                                                        fontFamily="Inter"
                                                                        fontSize="12px"
                                                                        lineHeight="100%"
                                                                        letterSpacing="0px"
                                                                        fontStyle="normal"
                                                                        style={{ fontWeight: 400 }}>
                                                                        {classData?.branch_id?.branch_name}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>


                                                            <Grid item xs={12} sm={6}  display="flex" alignItems="center"  flexDirection="row" gap={1}>
                                                           
                                                                    <Box  width={30} flexShrink={0}>
                                                                        <img src='/newdashboard/Checkout/Group 1171283449 (4).png'  
                                                                        style={{ 
                                                                            
  maxWidth: "100%",
  height:"auto",
  display: "block",

                                                                        }}/>
                                                                    </Box>
                                                                    <Box>
                                                                    <Typography textAlign="start"
                                                                        color="#000000"
                                                                        fontFamily="Inter"
                                                                        fontSize="12px"
                                                                        lineHeight="1.4"
                                                                        letterSpacing="0.1px"
                                                                        fontStyle="normal"
                                                                        flexWrap="wrap"
                                                                        style={{ fontWeight: 400 }}>
                                                                        {classData?.branch_id?.address}
                                                                    </Typography>
                                                              </Box>
                                                            </Grid>
                                                        </>
                                                    )}


                                                    {classData?.mode_of_delivery === "online" && (

                                                        <Grid item xs={12} sm={6}  >
                                                            <Box display="flex" alignItems="center" flexDirection="row" gap={1}>
                                                                <Box width={30} >
                                                                    <img src='/newdashboard/Checkout/Group 1171283449 (4).png' />
                                                                </Box>
                                                                <Typography textAlign="start"
                                                                    color="#000000"
                                                                    fontFamily="Inter"
                                                                    fontSize="12px"
                                                                    lineHeight="100%"
                                                                    letterSpacing="0px"
                                                                    fontStyle="normal"
                                                                    style={{ fontWeight: 400 }}>
                                                                    Online Class
                                                                </Typography>
                                                            </Box>
                                                        </Grid>



                                                    )}









                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>

                            </Grid>




                        </Grid>

                    </Card>

                </Grid>

                <Grid item xs={12} mt={1}>
                    {startDate && (
                        <PrimarySmallBlueButton onClick={handleNavigateToCheckout} buttonTitle="Confirm & Checkout" width="100%" startIcon={<img
                            src="/newdashboard/Checkout/f7_paperplane-fill.png"
                            alt="Default Icon"

                        />} />
                    )}

                    {!startDate && (
                        <DisableBlueSmallButton buttonTitle="Confirm & Checkout" width="100%" startIcon={<img
                            src="/newdashboard/Checkout/f7_paperplane-fill.png"
                            alt="Default Icon"

                        />} />
                    )}
                </Grid>
            </Grid>


            <ConfimationPopup
                handleClose={handleCloseErrorPopup}
                component={
                    <ErrorPopup
                        handleClose={handleCloseErrorPopup}
                        const
                        text="Error"
                        subText={errorMessage}
                        buttonTitle="Continue"
                        // startIcon={<ArticleIcon />}
                        navigateLink="/test-prep/demos"
                    />
                }
                open={openErrorPopup}
                subtitle=""
                maxWidth="xs"
            />


        </>
    )
}
